import api from './api';

export interface AdditionalCostItemTypeAdmin {
  id: number;
  name: string;
  sortOrder: number;
  isActive: boolean;
}

export interface AdditionalCostItemTypeCreate {
  name: string;
  sortOrder: number;
  isActive: boolean;
}

export type AdditionalCostItemTypePatch = Partial<AdditionalCostItemTypeCreate>;

export const additionalCostItemTypesService = {
  async list(): Promise<AdditionalCostItemTypeAdmin[]> {
    const res = await api.get('/admin/additional-cost-item-types');
    return res.data;
  },

  async create(
    payload: AdditionalCostItemTypeCreate,
  ): Promise<AdditionalCostItemTypeAdmin> {
    const res = await api.post('/admin/additional-cost-item-types', payload);
    return res.data;
  },

  async update(
    id: number,
    patch: AdditionalCostItemTypePatch,
  ): Promise<AdditionalCostItemTypeAdmin> {
    const res = await api.put(`/admin/additional-cost-item-types/${id}`, patch);
    return res.data;
  },

  async deactivate(id: number): Promise<void> {
    await api.delete(`/admin/additional-cost-item-types/${id}`);
  },
};
